import { RouteConfig } from "vue-router";

export const RTasksTemplate: RouteConfig = {
  path: ":taskId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "tasks-template" */
      "./VTasksTemplate.vue"
    ),
  meta: {
    backLink: "/tasks",
    hide: true,
    version: 2,
  },
};
